import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children", "tooltipProps", "disabled"];
import React from 'react';
import { Box, TextButton, Text } from '@wix/design-system';
import { StatusesModule } from '../StatusesModule';
import { DomainSearchSuiteModule } from '../../../../../domainSearchSuite.module';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { MobileAwareDisabledExplainer } from '../../../../../../components/MobileAwareDisabledExplainer';
export const PurchaseRootIsRequired = _ref => {
  let domainName = _ref.domainName,
    action = _ref.action;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    Trans = _DomainSearchSuiteMod.Trans;
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useGetPurchasePermissions({}),
    permission = _DomainsApiClient$hoo.data;
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    marginTop: "SP4",
    dataHook: StatusesModule.internals.dataHooks.purchaseRootIsRequired,
    textAlign: "center",
    paddingInline: "SP10"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.subdomain.unregistered_primary",
    values: {
      domainName
    },
    components: [permission != null && permission.hasPermission ? /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "normal",
      underline: "always",
      onClick: action,
      dataHook: StatusesModule.internals.dataHooks.domainIsTakenAction
    }) : /*#__PURE__*/React.createElement(TextButtonWithPermissions, {
      size: "small",
      weight: "normal",
      underline: "always",
      disabled: !(permission != null && permission.hasPermission),
      onClick: action
    })]
  })));
};
export const TextButtonWithPermissions = _ref2 => {
  let children = _ref2.children,
    tooltipProps = _ref2.tooltipProps,
    disabled = _ref2.disabled,
    buttonProps = _objectWithoutPropertiesLoose(_ref2, _excluded);
  const _DomainSearchSuiteMod2 = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod2.t;
  return /*#__PURE__*/React.createElement(Box, {
    inline: true
  }, /*#__PURE__*/React.createElement(MobileAwareDisabledExplainer, {
    disabled: disabled,
    content: t('domain_search_suite.error.domain_manager_permissions.tooltip'),
    tooltipProps: {
      ...tooltipProps,
      appendTo: document.body
    }
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TextButton, _extends({}, buttonProps, {
    disabled: disabled
  }), children))));
};
//# sourceMappingURL=PurchaseRootIsRequired.js.map